import React, { useEffect, useState } from "react";
import axios from "axios";
import constants from "../Constants";
import FormatHelper from "../helper/FormatHelper";
import {
	Avatar,
	Box,
	Card,
	CardContent,
	CardHeader,
	CircularProgress,
	Dialog,
	Divider,
	Grid,
	Typography,
	Pagination,
} from "@mui/material";

export default function League({ open, setOpen }) {
	const [data, setData] = useState([]);
	const [loading, setLoading] = useState(false);
	const [activePage, setActivePage] = useState(1);
	const limitState = 10;

	const fetchLeague = async (page = 1) => {
		try {
			setLoading(true);
			const res = await axios.get(
				constants.baseUrl + `/school/league?page=${page}&limit=${limitState}`,
				{
					headers: {
						authorization: "Bearer " + localStorage.getItem("schoolToken"),
					},
				}
			);
			if (res.data.status === 202) {
				setData(res.data.result.league);
			} else {
				setLoading(false);
			}
			setLoading(false);
		} catch (error) {
			console.log(error);
			setLoading(false);
		}
	};

	useEffect(() => {
		if (open) {
			fetchLeague();
		}
	}, [open]);

	return (
		<Dialog onClose={() => setOpen(false)} fullWidth open={open}>
			<Box p={2}>
				<Typography fontSize={16} fontWeight={"bold"}>
					لیگ هفتگی
				</Typography>
				<Divider sx={{ mb: 1 }} />
				{loading ? (
					<CircularProgress color="secondary" sx={{ my: 2 }} />
				) : data.length > 0 ? (
					<Box>
						<Grid container spacing={2}>
							{data.map((item, index) => {
								return (
									<Grid item xs={12} sm={6} key={index}>
										<Card sx={{ p: 1 }}>
											<CardHeader
												sx={{ p: 0, direction: "ltr" }}
												avatar={
													item.user.avatar && (
														<Avatar
															sx={{ width: 70, height: 70 }}
															src={`${constants.baseUrl}/user/avatar/${item.user.avatar}`}
															alt={`${item.user.firstName}-avatar`}
														/>
													)
												}
												title={`${item.user.firstName} ${item.user.lastName}`}
											/>
											<CardContent sx={{ p: 0 }}>
												<Typography mb={0.5}>رتبه: {item.sort}</Typography>
												<Typography mb={0.5}>رشته: {item.user.grade.name}</Typography>
												<Typography mb={0.5}>
													تعداد عملکرد: {FormatHelper.toPersianString(item.count.toString())}
												</Typography>
												<Typography mb={0.5}>
													مجموع:{" "}
													{FormatHelper.toPersianString(
														FormatHelper.convertMinuteToHours(item.sum)
													)}{" "}
													ساعت
												</Typography>
												<Typography mb={0.5}>مشاور: {item.user.advisor}</Typography>
											</CardContent>
										</Card>
									</Grid>
								);
							})}
						</Grid>
						<Pagination
							count={data.length ? Math.ceil(data[0].participants / limitState) : 0}
							page={activePage}
							onChange={(e, page) => {
								setActivePage(page);
								fetchLeague(page, limitState);
							}}
							sx={{ my: 3 }}
						/>
					</Box>
				) : (
					<Typography>هیچ کاربر واجد شرایط در لیگ موجود نیست !</Typography>
				)}
			</Box>
		</Dialog>
	);
}
